<template>
  <div class="settings-page page">
    <div class="page-header">
      <h1>Settings</h1>
      <p>
        This app is awesome, but sometimes you might want a little more control. <br>
        We've got you covered 😤.
      </p>
    </div>
    
    <el-row :gutter="20">
      <el-col :span="16" :offset="4">
        <el-card shadow="never">


          <el-form ref="settings-form" :model="form" label-width="120px" size="large">
            <el-form-item label="Maximum likes">
              <el-switch v-model="form.delivery"></el-switch>
            </el-form-item>
            <el-form-item>
              Leave maximum likes enabled to get the most gold
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data () {
    return {
      title: 'Settings',
      form: {
        name: 'lol'
      }
    }
  }
}
</script>
